import autocomplete from 'autocompleter'
import populateSubmitterItem from './populate_submitter_item'

export default class extends HTMLElement {
  connectedCallback () {
    this.autocomplete = autocomplete({
      input: this.input,
      preventSubmit: 1,
      minLength: 1,
      showOnFocus: true,
      debounceWaitMs: 200,
      onSelect: this.onSelect,
      render: this.render,
      fetch: this.fetch
    })
  }

  disconnectedCallback () {
    // Sem isto a lib `autocompleter` deixa para trás listeners em window/document
    // (resize/scroll) e o dropdown anexado ao body a cada item removido/navegação —
    // 5 por signatário no envio, acumulando memória até travar a aba.
    this.autocomplete?.destroy()
  }

  onSelect = (item) => {
    populateSubmitterItem(this.closest('submitter-item'), item)
  }

  fetch = (text, resolve) => {
    const q = this.dataset.field === 'email'
      ? text.split(/[;,\s]+/).pop().trim()
      : text

    if (q) {
      const queryParams = new URLSearchParams({ q, field: this.dataset.field })

      this.currentFetch ||= fetch('/submitters_autocomplete?' + queryParams)

      this.currentFetch.then(async (resp) => {
        const items = await resp.json()

        resolve(items)
      }).catch(() => {
        resolve([])
      }).finally(() => {
        this.currentFetch = null
      })
    } else {
      resolve([])
    }
  }

  render = (item) => {
    const div = document.createElement('div')

    div.setAttribute('dir', 'auto')

    div.textContent = item[this.dataset.field]

    return div
  }

  get input () {
    return this.querySelector('input') || this.querySelector('textarea')
  }
}
